import React from "react";
import { Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { RemoveCircleOutline } from "@mui/icons-material";
import { EventWWMember } from "../../../types/eventTypes";

interface WorkingWeekendParticipantsTableProps {
  workingWeekendParticipants: EventWWMember[];
  onRemoveParticipant: (memberId: number) => Promise<void>;
}

/**
 * Table for displaying the participants of the working weekend and their respective information.
 * @returns table with participants of the working weekend
 */
const WorkingWeekendParticipantsTable: React.FunctionComponent<WorkingWeekendParticipantsTableProps> = ({
  workingWeekendParticipants,
  onRemoveParticipant,
}: WorkingWeekendParticipantsTableProps) => {
  return (
    <TableContainer sx={{ borderRadius: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: "primary.main" }}>
            <TableCell
              sx={{
                color: "white",
                fontWeight: "bold",
                border: "1px solid white",
                borderBottom: "1px solid black",
                minWidth: 200,
              }}
            >
              Name
            </TableCell>
            <TableCell
              sx={{ color: "white", fontWeight: "bold", border: "1px solid white", borderBottom: "1px solid black" }}
            >
              Anreise
            </TableCell>
            <TableCell
              sx={{ color: "white", fontWeight: "bold", border: "1px solid white", borderBottom: "1px solid black" }}
            >
              Geplante <br /> Abreise
            </TableCell>
            <TableCell
              sx={{ color: "white", fontWeight: "bold", border: "1px solid white", borderBottom: "1px solid black" }}
            >
              Auto
            </TableCell>
            <TableCell
              sx={{ color: "white", fontWeight: "bold", border: "1px solid white", borderBottom: "1px solid black" }}
            >
              Vegetarier
            </TableCell>
            <TableCell
              sx={{ color: "white", fontWeight: "bold", border: "1px solid white", borderBottom: "1px solid black" }}
            >
              Kommentar
            </TableCell>
            <TableCell
              sx={{ color: "white", fontWeight: "bold", border: "1px solid white", borderBottom: "1px solid black" }}
            >
              Optionen
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {workingWeekendParticipants.map((participant) => (
            <TableRow key={participant.memberId}>
              <TableCell sx={{ border: "1px solid grey", borderTop: 0, borderLeft: 0 }}>
                {participant.firstName} {participant.lastName}
              </TableCell>
              <TableCell sx={{ border: "1px solid grey", borderTop: 0, borderLeft: 0, minWidth: 100 }}>
                {participant.arrival}
              </TableCell>
              <TableCell sx={{ border: "1px solid grey", borderTop: 0, borderLeft: 0, minWidth: 100 }}>
                {participant.departure}
              </TableCell>
              <TableCell sx={{ border: "1px solid grey", borderTop: 0, borderLeft: 0 }}>
                {participant.car ? "Ja, " + participant.seats : "Nein"}
              </TableCell>
              <TableCell sx={{ border: "1px solid grey", borderTop: 0, borderLeft: 0 }}>
                {participant.isVegetarian ? "Ja" : "Nein"}
              </TableCell>
              <TableCell sx={{ border: "1px solid grey", borderTop: 0, borderLeft: 0 }}>
                {participant.comment}
              </TableCell>
              <TableCell sx={{ border: "1px solid grey", borderTop: 0, borderLeft: 0, borderRight: 0 }}>
                <Chip
                  label="Abmelden"
                  color="error"
                  variant="outlined"
                  icon={<RemoveCircleOutline />}
                  onClick={() => onRemoveParticipant(participant.memberId)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default WorkingWeekendParticipantsTable;
